module.exports = __webpack_public_path__ + "static/media/raiting.567e3163.svg";